<template>
	<!-- 客户管理 -->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">
			<div class="pulbic_oparetionBlock">
				<div class="public_criteriaRange customerManagementPC-select">
					<div class="public_oparetionBlock_Menu">
						<label class="public_lbSty">客户名称：</label>
						<!-- <el-select class="public_optionSty dropDown_Define" v-model="cusQueryName" placeholder="请选择"
							filterable clearable>
							<el-option v-for="item in customerOptionsAll" :key="item.ORMTB410ID"
								:label="item.ORMTB410CA00" :value="item.ORMTB410CA00">
							</el-option>
						</el-select> -->
						<EnhancedSelect v-model="cusQueryName" :options="customerOptionsAll" label-key="ORMTB410CA00"
							value-key="ORMTB410CA00" pinyin-key="ORMTB410CA13" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
					</div>
				</div>
				<div class="customerManagementPC-btn public_operatBtn" style="margin-left: 0px;">
					<el-button class="public_saleWater_xinzeng" type="primary" @click="tableDetilsClick">
						<i class="iconfont icon-tianjia1"></i>优惠设置
					</el-button>
					<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
						@click="querycusList()">
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
				</div>
			</div>
			<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
				<el-table :data="tableData" height="580" style="width: 100%" stripe class="public_tableColumn"
					:header-cell-style="{
						color: 'rgba(51,51,51,1)',
						background: 'rgba(184,227,255,1)',
						'font-weight': 'bold',
					}">
					<el-table-column prop="ORMTB410CA00" label="客户名称"></el-table-column>
					<el-table-column prop="ORMTB410CA06" label="客户等级">
						<template slot-scope="scope">
							<p>
								<span>{{ scope.row.ORMTB410CA06Name }}</span>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
								@click="viewClick(scope.row)">查看
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40, 100, 200]"
						layout="total, sizes,prev, pager, next" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>
			<div class="public-dialog">
				<el-dialog title="优惠设置" :visible.sync="levelmangShow" @close="" width="70%" :closeOnClickModal='false'>
					<div class="levelmang-title">
						<div class="levelmang_btn" @click="selectTab(item.value)" v-for="item in tabList"
							:key="item.value" :class="tabIndex == item.value ? 'levelmang-title-active' : ''">{{
								item.name }}</div>
					</div>
					<!-- 等级优惠设置 -->
					<div v-if="tabIndex == 1" :key="'grade-' + tabIndex">
						<div class="public_criteriaRange">
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">企业：</label>
								<!-- <el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwo"
									placeholder="请选择" filterable clearable>
									<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="enterpriseTwo" :options="enterpriseTwoOptionList" label-key="SETTB99CA00"
							value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
							</div>
							<el-button class="public_saleWater_chaxun" type="primary" id="查询"
								@click="queryGradePreLsit">查询</el-button>
						</div>
						<ul class="levelmang-table">
							<li class="levelmang-table-head">
								<div class="levelmang-table-CQ">
									厂区名称
								</div>
								<div class="levelmang-table-JB">
									级别
								</div>
								<div class="levelmang-table-KJ">
									单价扣减
								</div>
								<div class="levelmang-table-ZK">
									整车折扣
								</div>
								<div class="levelmang-table-YH">
									整车优惠
								</div>
							</li>
							<li class="levelmang-table-li" v-for="(item, index) in tableDataGradePre" :key="index">
								<div class="levelmang-table-CQ levelmang-table-CQ-list">
									<div>{{ item.SETTB99CA00 }}</div>
								</div>
								<div class="levelmang-table-li-tab">
									<div class="levelmang-table-li-tab-li" v-for="(items, indexs) in item.settb400List"
										:key="indexs">
										<div class="levelmang-table-JB">
											{{ items.SETTB400CA05Name }}
										</div>
										<div class="levelmang-table-KJ public-chech-details">
											<el-input-number :precision="2" :step="1" :min="0" :max="100"
												v-model="items.djkj"></el-input-number>元
										</div>
										<div class="levelmang-table-ZK">
											<input type="text" v-model="items.zczk" />%
										</div>
										<div class="levelmang-table-YH">
											<input type="text" v-model="items.zcyh" />元
										</div>
									</div>
								</div>
							</li>
						</ul>
						<div class="salesPreferentialDig-btn">
							<!-- @click="submissionGradePre" -->
							<el-button type="primary" @click="submisyhsionGradePre">提交</el-button>
							<el-button type="warning" @click="ResetGradePre">重置</el-button>
						</div>
					</div>
					<!-- 额外优惠设置(新增接口) -->
					<div v-if="tabIndex == 2" :key="'extra-' + tabIndex">
						<div class="public_criteriaRange">
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">客户名称：</label>
								<!-- <el-select class="public_optionSty dropDown_Define" v-model="cusQueryNameExtra"
									placeholder="请选择" filterable clearable>
									<el-option v-for="item in customerOptions" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="cusQueryNameExtra" :options="customerOptions" label-key="ORMTB410CA00"
							value-key="ORMTB410ID" pinyin-key="ORMTB410CA13" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
							</div>
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">企业名称：</label>
								<!-- <el-select class="public_optionSty dropDown_Define" v-model="enterpriseTwoExtra"
									placeholder="请选择" filterable clearable>
									<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="enterpriseTwoExtra" :options="enterpriseTwoOptionList" label-key="SETTB99CA00"
							value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
							</div>
							<el-button class="public_saleWater_chaxun" type="primary" id="查询"
								@click="querycusListExtra">查询</el-button>
						</div>
						<div>
							<el-button class="public_saleWater_chaxun public_saleWater_xinzeng"
								style="border-color: rgba(253, 183, 37, 1);" type="primary" id="添加额外优惠"
								@click="addDiscounts">添加额外优惠</el-button>
						</div>
						<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="tableDataExtra" height="580" style="width: 100%" stripe
								class="public_tableColumn" :header-cell-style="{
									color: 'rgba(51,51,51,1)',
									background: 'rgba(184,227,255,1)',
									'font-weight': 'bold',
								}">
								<el-table-column prop="SETTB414CA08" label="客户名称"></el-table-column>
								<el-table-column prop="SETTB414CA02" label="企业名称"></el-table-column>
								<el-table-column prop="SETTB414CA03" label="单价扣减(元)"></el-table-column>
								<el-table-column prop="SETTB414CA05" label="整车优惠(元)"></el-table-column>
								<el-table-column prop="SETTB414CA04" label="整车折扣(%)"></el-table-column>
								<el-table-column prop="SETTB414CA07" label="是否执行企业账户单个物料优惠">
									<template slot-scope="scope">
										<p>
											<span>{{ scope.row.SETTB414CA07 == 1 ? '否' : '是' }}</span>
										</p>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<div class="customerManagementPC-table-btn">
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												size="small" @click="editExtra(scope.row)">修改
											</el-button>
											<el-button type="primary" class="public_icon_xiugai public_icon_width"
												size="small" @click="deleteExtraList(scope.row)">删除
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="customerManagementPC-page">
								<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
									:current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 40, 100, 200]"
									layout="total, sizes,prev, pager, next" :page-size="pagesize2"
									:total="count2"></el-pagination>
							</div>
						</div>
					</div>
					<div v-if="tabIndex == 3" :key="'tax-' + tabIndex">
						<div class="public_criteriaRange">
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">客户名称：</label>
								<!-- <el-select class="public_optionSty dropDown_Define" v-model="taxObj.ORMTB410ID"
									placeholder="请选择" filterable clearable>
									<el-option v-for="item in customerOptions" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="taxObj.ORMTB410ID" :options="customerOptions" label-key="ORMTB410CA00"
							value-key="ORMTB410ID" pinyin-key="ORMTB410CA13" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
							</div>
							<div class="public_oparetionBlock_Menu">
								<label class="public_lbSty">企业名称：</label>
								<!-- <el-select class="public_optionSty dropDown_Define" v-model="taxObj.SETTB99ID"
									placeholder="请选择" filterable clearable>
									<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="taxObj.SETTB99ID" :options="enterpriseTwoOptionList" label-key="SETTB99CA00"
							value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
							</div>
							<el-button class="public_saleWater_chaxun" type="primary" id="查询"
								@click="querycusListTax">查询</el-button>
						</div>
						<div>
							<el-button class="public_saleWater_chaxun public_saleWater_xinzeng"
								style="border-color: rgba(253, 183, 37, 1);" type="primary" id="新增"
								@click="addTaxlist">新增</el-button>
						</div>
						<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="tableDataTax" height="580" style="width: 100%" stripe
								class="public_tableColumn" :header-cell-style="{
									color: 'rgba(51,51,51,1)',
									background: 'rgba(184,227,255,1)',
									'font-weight': 'bold',
								}">
								<el-table-column prop="ORMTB703CA01" label="客户名称"></el-table-column>
								<el-table-column prop="ORMTB703CA03" label="企业名称"></el-table-column>
								<el-table-column prop="" label="物料信息">
									<template slot-scope="scope">
										<el-button type="primary" class="public_icon_xiugai public_icon_width"
											size="small" @click="materialTax(scope.row)">物料列表
										</el-button>
									</template>
								</el-table-column>
								<el-table-column prop="" label="状态">
									<template slot-scope="scope">
										<span>已开启含税价</span>
									</template>
								</el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button type="primary" class="public_icon_xiugai public_icon_width"
											size="small" @click="taxClose(scope.row)">关闭
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="customerManagementPC-page">
								<el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
									:current-page.sync="currentPage3" :page-sizes="[10, 20, 30, 40, 100, 200]"
									layout="total, sizes,prev, pager, next" :page-size="pagesize3"
									:total="count3"></el-pagination>
							</div>
						</div>
					</div>
					<div v-if="tabIndex == 4" :key="'material-' + tabIndex">
						<div class="public_criteriaRange">
							<el-button class="public_saleWater_chaxun public_saleWater_xinzeng"
								style="border-color: rgba(253, 183, 37, 1);" type="primary" id="新增"
								@click="addMateriallist">新增</el-button>
						</div>
						<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
							<el-table :data="tableDataMaterial" height="580" style="width: 100%" stripe
								class="public_tableColumn" :header-cell-style="{
									color: 'rgba(51,51,51,1)',
									background: 'rgba(184,227,255,1)',
									'font-weight': 'bold',
								}">
								<el-table-column prop="SETTB419CA02" label="企业名称"></el-table-column>
								<el-table-column prop="SETTB419CA04" label="物料"></el-table-column>
								<el-table-column prop="SETTB419CA09" label="等级"></el-table-column>
								<el-table-column prop="SETTB419CA06" label="类型">
									<template slot-scope="scope">
										<span>{{ scope.row.SETTB419CA06 == 1 ? '上涨' : '下调' }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="SETTB419CA07" label="金额"></el-table-column>
								<el-table-column label="操作">
									<template slot-scope="scope">
										<el-button type="primary" class="public_icon_xiugai public_icon_width"
											size="small" @click="materialListDelect(scope.row)">删除
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="customerManagementPC-page">
								<el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4"
									:current-page.sync="currentPage4" :page-sizes="[10, 20, 30, 40, 100, 200]"
									layout="total, sizes,prev, pager, next" :page-size="pagesize4"
									:total="count4"></el-pagination>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="优惠信息" @close="pageMo = 1, limitMo = 10" :visible.sync="yhPreferentialShow" width="70%"
					:closeOnClickModal='false'>
					<div id="">
						<ul class="levelmang-table">
							<li class="levelmang-table-head">
								<div class="levelmang-table-CQ">
									厂区名称
								</div>
								<div class="levelmang-table-JB">
									级别
								</div>
								<div class="levelmang-table-KJ">
									优惠单价
								</div>
								<div class="levelmang-table-ZK">
									整车折扣
								</div>
								<div class="levelmang-table-YH">
									整车优惠
								</div>
							</li>
							<li class="levelmang-table-li" v-for="(item, index) in tableDatayhGradePre" :key="index">
								<div class="levelmang-table-CQ levelmang-table-CQ-list">
									<div>{{ item.name }}</div>
								</div>
								<div class="levelmang-table-li-tab">
									<!-- v-for="(items,indexs) in tableDatayhGradePre" :key="indexs" -->
									<div class="levelmang-table-li-tab-li">
										<div class="levelmang-table-JB">
											{{ item.SETTB400CA05Name }}
										</div>
										<div class="levelmang-table-KJ public-chech-details">
											<div>{{ item.djkj }}</div>

										</div>
										<div class="levelmang-table-ZK">
											<div>{{ item.zczk }}%</div>
										</div>
										<div class="levelmang-table-YH">
											<div>{{ item.zcyh }}元</div>
										</div>
									</div>
								</div>
							</li>
						</ul>

						<div class="salesPreferentialDig-btn">
							<el-button type="primary" @click="submissionGradePre">确定保存</el-button>
							<el-button type="warning" @click="yhPreferentialShow = false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 添加额外优惠弹窗 -->
			<div class="public-dialog">
				<el-dialog :title="editFlag ? '添加额外优惠' : '修改额外优惠'" :visible.sync="discountsFlag" width="92%" @close=""
					:closeOnClickModal="false">
					<el-button v-if="editFlag" type="primary" @click="addNewRow"
						style="margin-bottom: 10px;">添加</el-button>
					<el-table class="public_tableColumn" ref="multipleTable" :data="tableDatayh" tooltip-effect="dark"
						:header-cell-style="{
							color: 'rgba(51,51,51,1)',
							background: 'rgba(184,227,255,1)',
							'font-weight': 'bold',
						}" height="700" style="width: 100%">
						<el-table-column label="客户名称">
							<template slot-scope="scope">
								<!-- <el-select v-model="scope.row.SETTB414CA00" placeholder="请选择客户名称" filterable
									@change="getLevelName(scope.$index)" :disabled="!editFlag">
									<el-option v-for="item in customerOptionsAll" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="scope.row.SETTB414CA00" :options="customerOptionsAll" label-key="ORMTB410CA00"
							value-key="ORMTB410ID" pinyin-key="ORMTB410CA13" :enable-pinyin-search="true"
							:enable-first-letter-search="true" @change="getLevelName(scope.$index)" :disabled="!editFlag" />
							</template>
						</el-table-column>
						<el-table-column label="企业名称">
							<template slot-scope="scope">
								<!-- <el-select v-model="scope.row.SETTB414CA02" placeholder="请选择企业名称"
									@change="getLevelProduct(scope.$index)" filterable>
									<el-option v-for="item in enterpriseTwoOptionListAll" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99CA00">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="scope.row.SETTB414CA02" :options="enterpriseTwoOptionListAll" label-key="SETTB99CA00"
							value-key="SETTB99CA00" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" @change="getLevelProduct(scope.$index)" />
							</template>
						</el-table-column>
						<el-table-column prop="djkj" label="等级单价优惠"></el-table-column>
						<el-table-column prop="zcyh" label="等级整车优惠"></el-table-column>
						<el-table-column prop="zczk" label="等级整车折扣"></el-table-column>
						<el-table-column prop="SETTB414CA03" label="单价扣减(元)">
							<template slot-scope="scope">
								<el-input v-model="scope.row.SETTB414CA03" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA05" label="整车优惠(元)">
							<template slot-scope="scope">
								<el-input v-model="scope.row.SETTB414CA05" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA04" label="整车折扣(%)">
							<template slot-scope="scope">
								<el-input v-model="scope.row.SETTB414CA04" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA07" width="240" label="是否享受统一单个物料优惠">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB414CA07" @change="dgwlyhFun" placeholder="请选择">
									<el-option v-for="item in dgwlyhOptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB414CA07" label="物料信息">
							<template slot-scope="scope">
								<el-button v-if="scope.row.SETTB414CA07 == '1'" type="primary"
									class="public_icon_xiugai public_icon_width" size="small"
									@click="slmsgClick(scope.row)">物料信息
								</el-button>
							</template>
						</el-table-column>
						<el-table-column label="操作" v-if="editFlag">
							<template slot-scope="scope">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
									@click="deleteRow(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="salesPreferentialDig-btn" style="margin-top: 20px">
						<el-button type="primary" @click="khyhserve()">提交</el-button>
						<el-button type="warning" @click="khyhqx()">取消</el-button>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="物料信息" :visible.sync="materShow" width="70%" :closeOnClickModal="false">
					<div class="public-chech systemCorporateAccount-dialog">
						<div class="public-chech-details">
							<div class="public-chech-details-tile">
								<div class="public-chech-details-tile-pre">物料类型：</div>
								<div class="public-chech-details-tile-pre-sel systemCorporateAccount-wuliao-input">
									<el-select v-model="categoryMaterial">
										<el-option v-for="item in materialTypeList" :key="item.SETTB206CA00"
											:label="item.SETTB206CA01" :value="item.SETTB206CA00">
										</el-option>
									</el-select>
								</div>
								<div class="public-chech-details-tile-q">物料名称：</div>
								<div class="public-chech-details-tile-q-sel systemCorporateAccount-wuliao-input">
									<el-input type="text" v-model="nameMaterial" placeholder="请输入"></el-input>
								</div>
								<el-button type="primary" style="margin-left: 20px;" @click="MaterialQuery">查询
								</el-button>
							</div>
							<div class="pulbic_oparetionBlock pulbic_table_container">
								<el-table :data="materList" style="width: 100%" stripe max-height="90%"
									class="public_tableColumn" :header-cell-style="{
										color: 'rgba(51,51,51,1)',
										'font-weight': 'bold',
									}">
									<el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
									<el-table-column align="center" prop="SETTB206CA01" label="物料类型"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01_ys"
										label="零售价格"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01" label="优惠价格"></el-table-column>
									<!-- <el-table-column align="center" prop="SETTB109CA02" label="状态"></el-table-column> -->
									<!-- <el-table-column align="center" prop="SETTB109CA05" label="计量单位"></el-table-column> -->
									<!-- <el-table-column align="center" prop="SETTB109CB06" label="高度">
										<template slot-scope="scope">
											<span v-if="scope.row.SETTB109CB06">{{scope.row.SETTB109CB06}}</span>
											<span v-else>暂无数据</span>
										</template>

									</el-table-column>
									 -->
									<el-table-column align="center" label="操作" width="260">
										<template slot-scope="scope">
											<el-button class="public_icon_xiugai public_icon_width" type="info"
												size="small" @click="DiscountModify(scope.row)" id="优惠调控">
												优惠调控
											</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div class="pulbic_pagesize">
									<el-pagination @size-change="handleSizeChangeMaterial"
										@current-change="handleCurrentChangeMaterial"
										:current-page.sync="currentPageMaterial" :page-sizes="[10, 20, 30, 40]"
										:page-size="limitMaterial" layout="total,sizes, prev, pager, next"
										:total="pagingPageMaterial"></el-pagination>
								</div>
							</div>
						</div>
						<!-- <div class="public-dialog-btn">
							<el-button type="primary" @click="">保存</el-button>
							<el-button type="warning" @click="materShow=false">取消</el-button>
						</div> -->
					</div>
				</el-dialog>
			</div>

			<div class="public-dialog">
				<el-dialog title="优惠调控" :visible.sync="discountShow" width="25%"
					@close="discountShow = false; floatingType == ''" :closeOnClickModal="false">
					<div class="systemCorporateAccount-dialog">
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">用户名称<span>*</span></div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="userName" placeholder="请输入" readonly />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">企业名称<span>*</span></div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="enterNameMaterialModify"
									placeholder="请输入" readonly />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">物料名称<span>*</span></div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="nameMaterialModify"
									placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">上次单个物料优惠</div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="individualDiscount"
									placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">当前价格</div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="currentPrice" placeholder="请输入" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">浮动类型<span>*</span></div>
							<div class="SCADL-input">
								<el-radio v-model="floatingType" size="medium" label="1"
									@input="floatingTypeInput">上浮</el-radio>
								<el-radio v-model="floatingType" size="medium" label="2"
									@input="floatingTypeInput">下调</el-radio>
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">浮动金额<span>*</span></div>
							<div class="SCADL-input levelmang-table-KJ public-chech-details">
								<el-input-number class="num" style="text-align: center; font-size: 18px !important;"
									:precision="2" :step="1" :min="0" :max="100" v-model="floatingAmount"
									@input="floatingAmountInput">
								</el-input-number>元
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-li">
							<div class="SCADL-text">调整后价格</div>
							<div class="SCADL-input">
								<input :disabled="disabled" type="text" v-model="adjustedPrice" />
							</div>
						</div>
						<div class="systemCorporateAccount-dialog-btn">
							<el-button type="primary" @click="preservationDiscountModify">保存</el-button>
							<el-button type="warning" @click="discountShow = false; floatingType == ''">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 含税设置新增 -->
			<div class="public-dialog">
				<el-dialog title="含税设置新增" :visible.sync="taxFlag" width="70%" @close="" :closeOnClickModal="false">
					<el-button type="primary" @click="addTax" style="margin-bottom: 10px;">添加</el-button>
					<el-table class="public_tableColumn" ref="multipleTableTax" :data="tableDataTaxAdd"
						tooltip-effect="dark" :header-cell-style="{
							color: 'rgba(51,51,51,1)',
							background: 'rgba(184,227,255,1)',
							'font-weight': 'bold',
						}" height="700" style="width: 100%">
						<el-table-column prop="ORMTB703CA00" label="客户名称">
							<template slot-scope="scope">
								<!-- <el-select v-model="scope.row.ORMTB703CA00"
									@change="taxPreferentialChange(scope.$index)" placeholder="请选择" filterable>
									<el-option v-for="item in customerOptionsAll" :key="item.ORMTB410ID"
										:label="item.ORMTB410CA00" :value="item.ORMTB410ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="scope.row.ORMTB703CA00" :options="customerOptionsAll" label-key="ORMTB410CA00"
							value-key="ORMTB410ID" pinyin-key="ORMTB410CA13" :enable-pinyin-search="true"
							:enable-first-letter-search="true" @change="taxPreferentialChange(scope.$index)" />
							</template>
						</el-table-column>
						<el-table-column prop="ORMTB703CA02" label="企业名称">
							<template slot-scope="scope">
								<!-- <el-select v-model="scope.row.ORMTB703CA02" placeholder="请选择" filterable>
									<el-option v-for="item in enterpriseTwoOptionListAll" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="scope.row.ORMTB703CA02" :options="enterpriseTwoOptionListAll" label-key="SETTB99CA00"
							value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" />
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
									@click="deleteTax(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="salesPreferentialDig-btn" style="margin-top: 20px">
						<el-button type="primary" @click="taxSave">提交</el-button>
						<el-button type="warning" @click="taxFlag = false">取消</el-button>
					</div>
				</el-dialog>
			</div>
			<!-- 含税价设置物料信息列表 -->
			<div class="public-dialog">
				<el-dialog title="物料列表" :visible.sync="hanshuijiaShow" width="70%" :closeOnClickModal="false" @close="">
					<div class="public-chech systemCorporateAccount-dialog">
						<div class="public-chech-details">
							<div class="pulbic_oparetionBlock pulbic_table_container">
								<el-table :data="fdmaterList" style="width: 100%" stripe max-height="90%"
									class="public_tableColumn" :header-cell-style="{
										color: 'rgba(51,51,51,1)',
										'font-weight': 'bold',
									}">
									<el-table-column align="center" prop="SETTB99CA00" label="企业名称"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA00" label="物料名称"></el-table-column>
									<!-- <el-table-column align="center" prop="SETTB206CA01" label="物料类型"></el-table-column> -->
									<el-table-column align="center" prop="SETTB109CA01_ys"
										label="零售价格"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01" label="不含税价格"></el-table-column>
									<el-table-column align="center" prop="SETTB109CA01_hs"
										label="含税价格"></el-table-column>
									<!-- <el-table-column align="center" prop="SETTB420CA10"
										:label="labeText"></el-table-column> -->

									<!-- <el-table-column align="center" label="操作" width="260">
										<template slot-scope="scope">

											<el-button class="public_icon_xiugai public_icon_width" type="info"
												size="small" @click="deleteFd(scope.row)" id="删除">
												删除
											</el-button>
										</template>
									</el-table-column> -->
								</el-table>
								<div class="pulbic_pagesize">
									<el-pagination @size-change="hsjhandleSizeChangeMaterial"
										@current-change="hsjcurrentPageMaterial"
										:current-page.sync="hsjListpageMaterial" :page-sizes="[10, 20, 30, 40]"
										:page-size="hsjListlimitMaterial" layout="total,sizes, prev, pager, next"
										:total="hsjListpagingPageMaterial"></el-pagination>
								</div>
								<!-- <div class="systemCorporateAccount-dialog-btn" style="margin-top: 20px">
									<el-button type="primary" @click="hsjyhserve()">提交</el-button>
									<el-button type="warning" @click="hsjszCloFun()">取消</el-button>
								</div> -->
							</div>
						</div>
						<!-- <div class="public-dialog-btn">
	                <el-button type="primary" @click="">保存</el-button>
	                <el-button type="warning" @click="materShow=false">取消</el-button>
	              </div> -->
					</div>
				</el-dialog>
			</div>
			<!-- 物料等级设置新增 -->
			<div class="public-dialog">
				<el-dialog title="物料等级设置新增" :visible.sync="materialFlag" width="70%" @close=""
					:closeOnClickModal="false">
					<el-button type="primary" @click="addMaterial" style="margin-bottom: 10px">添加</el-button>
					<el-table class="public_tableColumn" ref="multipleTableMaterial" :data="tableDataMaterialAdd"
						tooltip-effect="dark" :header-cell-style="{
							color: 'rgba(51,51,51,1)',
							background: 'rgba(184,227,255,1)',
							'font-weight': 'bold',
						}" height="700" style="width: 100%">
						<el-table-column prop="SETTB419CA01" label="企业名称">
							<template slot-scope="scope">
								<!-- <el-select v-model="scope.row.SETTB419CA01" @change="erpChange(scope.$index)"
									placeholder="请选择">
									<el-option v-for="item in enterpriseTwoOptionListAll" :key="item.SETTB99ID"
										:label="item.SETTB99CA00" :value="item.SETTB99ID">
									</el-option>
								</el-select> -->
								<EnhancedSelect v-model="scope.row.SETTB419CA01" :options="enterpriseTwoOptionListAll" label-key="SETTB99CA00"
							value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" @change="erpChange(scope.$index)" />
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA03" label="物料">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA03" placeholder="请选择"
									@change="materielAddChange(scope.$index)">
									<el-option v-for="item in materielOptions" :key="item.SETTB109ID"
										:label="item.SETTB109CA00" :value="item.SETTB109ID">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA00" label="等级">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA00" placeholder="请选择">
									<el-option v-for="item in khdjOperation" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA06" label="类型">
							<template slot-scope="scope">
								<el-select v-model="scope.row.SETTB419CA06" @change="typeAddChange(scope.$index)"
									placeholder="请选择">
									<el-option v-for="item in adjustmentType" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="SETTB419CA07" label="金额">
							<template slot-scope="scope">
								<el-input type="text" v-model="scope.row.SETTB419CA07"
									@input="moneyAddInput(scope.$index)" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="money" label="调整后优惠金额">
							<template slot-scope="scope">
								<span>{{ scope.row.money }}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="primary" class="public_icon_xiugai public_icon_width" size="small"
									@click="deleteMaterial(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="salesPreferentialDig-btn" style="margin-top: 20px">
						<el-button type="primary" @click="materialSave">提交</el-button>
						<el-button type="warning" @click="materialFlag = false">取消</el-button>
					</div>
				</el-dialog>
			</div>
			<!-- 查看 -->
			<div class="public-dialog">
				<el-dialog :title="viewTitle" :visible.sync="viewFlag" width="90%" @close="" :closeOnClickModal="false">

					<div class="public_criteriaRange">
						<div class="public_oparetionBlock_Menu">
							<label class="public_lbSty">企业名称：</label>
							<!-- <el-select class="public_optionSty dropDown_Define" v-model="taxViewObj.SETTB99ID"
								placeholder="请选择" @change="enterpriseChange" filterable clearable>
								<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
									:label="item.SETTB99CA00" :value="item.SETTB99ID">
								</el-option>
							</el-select> -->
							<EnhancedSelect v-model="taxViewObj.SETTB99ID" :options="enterpriseTwoOptionList" label-key="SETTB99CA00"
							value-key="SETTB99ID" pinyin-key="SETTB99CA00PY" :enable-pinyin-search="true"
							:enable-first-letter-search="true" @change="enterpriseChange" />
						</div>
						<div class="public_oparetionBlock_Menu">
							<label class="public_lbSty">物料：</label>
							<el-select class="public_optionSty dropDown_Define" v-model="taxViewObj.SETTB109ID"
								placeholder="请选择" clearable>
								<el-option v-for="item in viewMaterialTypeList" :key="item.SETTB109ID"
									:label="item.SETTB109CA00" :value="item.SETTB109ID">
								</el-option>
							</el-select>
						</div>
						<el-button class="public_saleWater_chaxun" type="primary" id="查询"
							@click="viewQuery">查询</el-button>
					</div>
					<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">
						<el-table :data="tableDataView" height="580" style="width: 100%" stripe
							class="public_tableColumn" :header-cell-style="{
								color: 'rgba(51,51,51,1)',
								background: 'rgba(184,227,255,1)',
								'font-weight': 'bold',
							}">
							<el-table-column prop="qymc" label="企业名称" width="100"></el-table-column>
							<el-table-column prop="wlmc" label="物料" width="100"></el-table-column>
							<el-table-column prop="lsj" label="零售价" width="100"></el-table-column>
							<el-table-column prop="djyh_dj" label="单价优惠(等级)"></el-table-column>
							<el-table-column prop="zczk_dj" label="整车折扣(等级)"></el-table-column>
							<el-table-column prop="zcyh_dj" label="整车优惠(等级)"></el-table-column>
							<el-table-column prop="yhtk_dj" label="优惠调控(等级)"></el-table-column>
							<el-table-column prop="djyh_ew" label="单价优惠(额外)"></el-table-column>
							<el-table-column prop="zczk_ew" label="整车折扣(额外)"></el-table-column>
							<el-table-column prop="zcyh_ew" label="整车优惠(额外)"></el-table-column>
							<el-table-column prop="yhtk_ew" label="优惠调控(额外)"></el-table-column>
							<el-table-column prop="wldjyh" label="物料等级优惠"></el-table-column>
							<el-table-column prop="ssjg" label="实时价格"></el-table-column>
							<el-table-column prop="hsjg" label="含税价格"></el-table-column>
						</el-table>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
import EnhancedSelect from './components/EnhancedSelect.vue';
export default {
	components: {
		EnhancedSelect
	},
	data() {
		return {
			uobj: this.$store.state.uobj, //登陆缓存--用户信息
			cusQueryName: '',
			tableData: [],
			count: 0,
			pagesize: 10,
			page: 1,
			currentPage: 1,
			tableDataExtra: [],
			count2: 0,
			pagesize2: 10,
			page2: 1,
			currentPage2: 1,
			count3: 0,
			pagesize3: 10,
			page3: 1,
			currentPage3: 1,
			count4: 0,
			pagesize4: 10,
			page4: 1,
			currentPage4: 1,
			levelmangShow: false,
			tableDataGradePre: [],
			enterpriseTwo: '',
			// enterpriseTwoOptionList: [],
			settb400List: [],
			tableDatayhGradePre: [],
			yhPreferentialShow: false,
			pageMo: 1, //默认列表页码
			limitMo: 10, //每页的条数
			tabIndex: 1,
			tabList: [
				{
					name: '等级优惠设置',
					value: 1
				},
				{
					name: '额外优惠设置',
					value: 2
				},
				{
					name: '含税价设置',
					value: 3
				},
				{
					name: '物料等级设置',
					value: 4
				},
			],
			discountsFlag: false,//添加额外优惠设置弹窗	
			tableDatayh: [
				{
					id: 1,
					SETTB414CA00: '',
					SETTB414CA01: '',
					SETTB414CA02: '',
					SETTB414CA03: '',
					SETTB414CA04: '',
					SETTB414CA05: '',
					SETTB414CA07: 1,
					SETTB414CA08: '',
					djkj: '',
					zcyh: '',
					zczk: ''
				}
			],
			tableDataTaxAdd: [
				{
					id: 1,
					ORMTB703CA00: "",
					ORMTB703CA01: "",
					ORMTB703CA02: "",
					ORMTB703CA04: 1,
				}
			],
			tableDataMaterialAdd: [{
				id: 1,
				SETTB419CA01: "",
				SETTB419CA02: "",
				SETTB419CA03: "",
				SETTB419CA04: "",
				SETTB419CA00: "",
				SETTB419CA06: "",
				SETTB419CA07: "",
				money: "",
			}],
			// 物料信息
			materShow: false,
			materList: [],
			materiaShowZJ: '', //判断是否显示新增，修改，禁用按钮
			categoryMaterial: '', //物料类别
			nameMaterial: '', //物料名称
			pageMaterial: 1, //默认列表页码
			limitMaterial: 10, //每页的条数
			pagingPageMaterial: 0, //分页--数据列表共有的条数
			currentPageMaterial: 1, //设置当前页默认为1
			materialTypeList: [],
			cjmsgobj: {},

			//优惠调控
			discountShow: false,
			floatingType: '', //浮动类型-上浮-下浮
			floatingAmount: 0, //浮动金额
			disabled: true,

			useryhmsg: {},

			enterNameMaterialModify: '', //企业名称
			nameMaterialModify: '', //物料名称
			wholesalePriceModify: '', //零售价格
			preferentialType: 0,
			solelist: [],
			cusUDJSetpdateShow: false,
			tableDataGradePre: [],
			innerVisible: false,
			dgwlyh: '',
			dgwlyhOptions: [
				{
					value: 0,
					label: '是',
				},
				{
					value: 1,
					label: '否',
				},
			],
			nextId: 2,
			tableDataTax: [],
			enterpriseTwoOptionList: [
				{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				},
			],
			customerOptions: [
				{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				},
			],
			customerOptionsAll: [],
			enterpriseTwoOptionListAll: [],
			taxFlag: false,
			taxId: 2,
			hanshuijiaShow: false,
			hsjList: [],
			hsjListpageMaterial: 1, //默认列表页码
			hsjListlimitMaterial: 10, //每页的条数
			hsjListpagingPageMaterial: 0, //分页--数据列表共有的条数
			hsjcurrentPageMaterial: 1, //设置当前页默认为1
			fdmaterList: [],
			taxObj: {
				SETTB99ID: '',
				ORMTB410ID: ''
			},
			taxViewObj: {
				SETTB99ID: '',
				SETTB109ID: ''
			},
			tableDataMaterial: [],
			materialFlag: false,
			materialId: 2,
			viewFlag: false,
			tableDataView: [],
			customerMo: '',
			cusQueryNameExtra: '',//额外优惠设置客户名称
			enterpriseTwoExtra: '',//额外优惠设置企业名称
			extraObj: {},
			editFlag: true,
			materielOptions: [],
			khdjOperation: [
				{
					value: '0301',
					label: '一级客户',
				},
				{
					value: '0302',
					label: '二级客户',
				},
				{
					value: '0303',
					label: '三级客户',
				},
				{
					value: '0304',
					label: '四级客户',
				},
				{
					value: '0305',
					label: '五级客户',
				},
				{
					value: '0306',
					label: '六级客户',
				},
				{
					value: '0307',
					label: '七级客户',
				},
				{
					value: '0308',
					label: '八级客户',
				},
				{
					value: '0309',
					label: '九级客户',
				},
			],
			adjustmentType: [
				{ value: 1, label: '上涨' },
				{ value: 2, label: '下调' }
			],
			nameId: '',
			productId: '',
			MaterialModify109ID: '',
			enterNameMaterialModify: '',
			nameMaterialModify: '',
			userName: '',//优惠调控-用户名称
			individualDiscount: '',//优惠调控-上次单个物料优惠
			currentPrice: 0,//优惠调控-当前价格
			adjustedPrice: '',//优惠调控-调整后价格
			taxProductId: '',
			taxName: '',
			viewMaterialTypeList: [
				{
					SETTB109CA00: '全部',
					SETTB109ID: ''
				}
			],
			viewNameId: '',
			nameTitle: '',
			viewTitle: '',
		}
	},
	watch: {
		'currentPrice': function (newVal, oldVal) {
			this.getAdjustedPrice();
		},
		'floatingType': function (newVal, oldVal) {
			this.getAdjustedPrice();
		}
	},
	created() {
		var list = "";
		list = this.$store.state.solelist;
		var path = this.$route.path;
		if (path === "/SalesPreferential") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		this.uobj = this.$store.state.uobj;
		// 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		sessionStorage.removeItem(this.currentUrl);
		if (this.historyInfo != null && this.historyInfo != "") {
			this.init();
		}
	},
	mounted() {
		this.querycusList()
		this.optionLists();
		this.enterprise0ptions();
	},
	methods: {
		enterpriseChange(value) {
			this.materielMoPost(value, 1);//查看弹窗调用
		},
		taxClose(row) {
			row.ORMTB703CA04 = 0;
			this.$confirm('此操作将关闭含税价, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = '/orm/ormtb703/changeTaX'
				var postData = [row];
				this.axios
					.post(url, postData)
					.then(res => {
						if (res.data.code == 200) {
							this.querycusListTax();
						} else {
							this.$message({
								message: res.data.message,
								type: 'error',
							})
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
			}).catch(() => {
				this.$message.info('已取关闭');
			});
		},
		floatingTypeInput() {
			this.getAdjustedPrice();
		},
		floatingAmountInput() {
			this.getAdjustedPrice();
		},
		getAdjustedPrice() {
			var url = '/set/settb109/selectPrice'
			this.axios.post(url, { ORMTB410ID: this.nameId, SETTB109ID: this.MaterialModify109ID, SETTB418CA06: this.floatingType, SETTB418CA07: this.floatingAmount, SETTB418CA10: this.currentPrice }).then(res => {
				if (res.data.code == 200) {
					this.adjustedPrice = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		materialListDelect(row) {
			this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = '/set/settb419/delete'
				this.axios.post(url, { SETTB419ID: row.SETTB419ID }).then(res => {
					if (res.data.code == 200) {
						this.$message.success(res.data.message);
						this.querycusListMetail();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})

			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		materielAddChange(index) {
			const row = this.tableDataMaterialAdd[index];
			const item = this.materielOptions.find(item => item.SETTB109ID === row.SETTB419CA03);
			this.$set(row, 'SETTB419CA04', item.SETTB109CA00);
			this.getMoneyData(row.SETTB419CA03, row.SETTB419CA06, row.SETTB419CA07, row)
		},
		typeAddChange(index) {
			const row = this.tableDataMaterialAdd[index];
			this.getMoneyData(row.SETTB419CA03, row.SETTB419CA06, row.SETTB419CA07, row)
		},
		moneyAddInput(index) {
			const row = this.tableDataMaterialAdd[index];
			this.getMoneyData(row.SETTB419CA03, row.SETTB419CA06, row.SETTB419CA07, row)
		},
		getMoneyData(SETTB419CA03, SETTB419CA06, SETTB419CA07, row) {
			var url = '/set/settb419/selectPrice'
			var data = {
				SETTB419CA03: SETTB419CA03,
				SETTB419CA06: SETTB419CA06,
				SETTB419CA07: SETTB419CA07,
			}
			this.axios.post(url, data).then(res => {
				if (res.data.code == 200) {
					this.$set(row, 'money', JSON.stringify(res.data.data) === '{}' ? '' : res.data.data);
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		erpChange(index) {
			const row = this.tableDataMaterialAdd[index];
			const item = this.enterpriseTwoOptionListAll.find(item => item.SETTB99ID === row.SETTB419CA01);
			this.$set(row, 'SETTB419CA02', item.SETTB99CA00);
			this.materielMoPost(row.SETTB419CA01);
		},
		materielMoPost(id, type) {
			var url = '/set/settb109/selectPageList'
			var data = {
				SETTB99ID: id,
				page: 1,
				limit: 1000,
			}
			let list = [
				{
					SETTB109CA00: '全部',
					SETTB109ID: ''
				}
			]
			this.axios.post(url, data).then(res => {
				if (res.data.code == 200) {
					if (type) {//查看弹窗调用
						this.viewMaterialTypeList = [...list, ...res.data.data];
					} else {
						this.materielOptions = res.data.data;
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		deleteExtraList(row) {
			this.$confirm('此操作将删除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = '/set/settb414/delete'
				this.axios.post(url, { SETTB414ID: row.SETTB414ID }).then(res => {
					if (res.data.code == 200) {
						this.$message.success(res.data.message);
						this.querycusListExtra();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})

			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		// 额外优惠设置修改
		editExtra(row) {
			this.discountsFlag = true;
			this.editFlag = false;
			this.extraObj = row;
			let obj = { ...this.extraObj, id: 1 }
			this.tableDatayh = [obj];
			this.getLevelData(row.SETTB414CA00, row.SETTB414CA01, obj);
		},
		getLevelName(index) {
			const row = this.tableDatayh[index];
			const item = this.customerOptionsAll.find(item => item.ORMTB410ID === row.SETTB414CA00);
			this.$set(row, 'SETTB414CA08', item.ORMTB410CA00);
			this.getLevelData(row.SETTB414CA00, row.SETTB414CA01, row);
		},
		getLevelProduct(index) {
			const row = this.tableDatayh[index];
			const item = this.enterpriseTwoOptionListAll.find(item => item.SETTB99CA00 === row.SETTB414CA02);
			this.$set(row, 'SETTB414CA01', item.SETTB99ID);
			this.getLevelData(row.SETTB414CA00, row.SETTB414CA01, row);
		},
		// 额外优惠设置获取等级优惠
		getLevelData(ORMTB410ID, SETTB99ID, row) {
			var url = '/set/settb414/selectPrice'
			this.axios.post(url, { ORMTB410ID: ORMTB410ID, SETTB99ID: SETTB99ID }).then(res => {
				if (res.data.code == 200) {
					this.$set(row, 'djkj', res.data.data.djkj);
					this.$set(row, 'zcyh', res.data.data.zcyh);
					this.$set(row, 'zczk', res.data.data.zczk);
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		enterprise0ptions() {
			var postData = {}
			if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
				postData = {
					ORMTB400ID: this.uobj.ormtb410.ORMTB410ID, //一级企业id
				}
			}
			if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
				postData = {
					ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
				}
			}

			var List = [
				{
					ORMTB410ID: '',
					ORMTB410CA00: '全部',
				},
			]
			var url = '/orm/ormtb410/selectOrmtb410s'
			this.axios.post(url, postData).then(res => {
				console.log(res)

				if (res.data.code == 200) {
					// 客户
					this.customerOptions = [...List, ...res.data.data];
					this.customerOptionsAll = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		// 查看弹窗
		viewQuery() {
			// if (!this.taxViewObj.SETTB109ID) {
			// 	return this.$message({
			// 		message: '请选择物料',
			// 		type: 'warning',
			// 	})
			// }
			var url = '/set/settb109/selectPreferential'
			var postData = { ormtb410Id: this.viewNameId, SETTB99ID: this.taxViewObj.SETTB99ID, SETTB109ID: this.taxViewObj.SETTB109ID };
			this.axios
				.post(url, postData)
				.then(res => {
					if (res.data.code == 200) {
						console.log(res)
						this.tableDataView = res.data.data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
		},
		//查看按钮
		viewClick(row) {
			this.viewFlag = true;
			this.viewTitle = `${row.ORMTB410CA00}的优惠信息`;
			this.taxViewObj = {
				SETTB99ID: '',
				SETTB109ID: ''
			};
			this.tableDataView = [];
			this.viewNameId = row.ORMTB410ID;
			// this.viewQuery();
		},
		//含税设置客户名称选择
		taxPreferentialChange(index) {
			const row = this.tableDataTaxAdd[index];
			const item = this.customerOptionsAll.find(item => item.ORMTB410ID === row.ORMTB703CA00);
			this.$set(row, 'ORMTB703CA01', item.ORMTB410CA00);
		},
		//物料等级企业选择
		materialChange() {

		},
		taxSave() {
			if (this.tableDataTaxAdd.length == 0) {
				this.$message({
					message: '请添加数据',
					type: 'warning',
				})
				return
			} else {
				if (this.hasEmptyPropertyValue(this.tableDataTaxAdd)) {
					this.$message({
						message: '请填写完整的数据',
						type: 'warning',
					})
					return
				}
			}
			var url = '/orm/ormtb703/changeTaX'
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = this.tableDataTaxAdd;
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						this.taxFlag = false;
						this.querycusListTax();
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'error'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		//物料等级物理删除
		deleteMaterial(index) {
			this.$confirm('此操作将移除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.tableDataMaterialAdd.splice(index, 1);
				this.$message.success('删除成功');
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		//物料优惠新增
		addMateriallist() {
			this.materialFlag = true;
			this.materialId = 1;
			this.tableDataMaterialAdd = [{
				id: 1,
				SETTB419CA01: "",
				SETTB419CA02: "",
				SETTB419CA03: "",
				SETTB419CA04: "",
				SETTB419CA00: "",
				SETTB419CA06: "",
				SETTB419CA07: "",
				money: "",
			}]
		},
		// 物料等级保存
		materialSave() {
			if (this.tableDataMaterialAdd.length == 0) {
				this.$message({
					message: '请添加数据',
					type: 'warning',
				})
				return
			} else {
				if (this.hasEmptyPropertyValue(this.tableDataMaterialAdd)) {
					this.$message({
						message: '请填写完整的数据',
						type: 'warning',
					})
					return
				}
			}
			var url = '/set/settb419/save'
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				list: this.tableDataMaterialAdd,
			}
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						// console.log(res)
						this.materialFlag = false;
						this.querycusListMetail();
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'error'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		ykhsjChangJiaFun() {
			//查询已开启含税价厂家
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				ORMTB703CA02: this.taxObj.SETTB99ID,
				ORMTB703CA00: this.taxObj.ORMTB410ID,
				page: this.page3,
				limit: this.pagesize3
			}
			var url = '/orm/ormtb703/selectList'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.count3 = res.data.data.total;
						this.tableDataTax = res.data.data.list;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		selectwlhxPageListFun() {
			//根据厂家获取物料含税价和不含税价信息
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				SETTB99ID: this.taxProductId,
				ORMTB410ID: this.taxName,
				limit: this.hsjListlimitMaterial,
				page: this.hsjListpageMaterial,
			}
			var fdmoList
			var url = 'set/settb109/selectwlhxPageList'
			this.axios
				.post(url, postData)
				.then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						fdmoList = res.data.data.list
						this.fdmaterList = fdmoList
						this.hsjListpagingPageMaterial = res.data.count

						// if (res.data.data.taxSwitch == 0) {
						// 	this.hanshuijiaKG = false
						// 	this.hsjstus = 0
						// } else {
						// 	this.hanshuijiaKG = true
						// 	this.hsjstus = 1
						// }
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		// fdPageMaterialList(id) {
		// 	let loading = this.$loading({
		// 		lock: true,
		// 		text: '请求中...',
		// 		spinner: 'el-icon-loading',
		// 		background: 'rgba(0, 0, 0, 0.5)',
		// 	})
		// 	var postData = {
		// 		SETTB99ID: id,
		// 		SETTB109CD01: '',
		// 		limit: '1000',
		// 		page: '1',
		// 	}
		// 	var fdmoList
		// 	var url = 'set/settb109/selectPageList'
		// 	this.axios
		// 		.post(url, postData)
		// 		.then(res => {
		// 			// console.log(res)
		// 			setTimeout(() => {
		// 				loading.close()
		// 			}, 300)
		// 			if (res.data.code == 200) {
		// 				fdmoList = res.data.data
		// 				this.fdmaterList = fdmoList
		// 				this.fdpagingPageMaterial = res.data.count
		// 			} else {
		// 				this.$message({
		// 					message: res.data.message,
		// 					type: 'error',
		// 				})
		// 			}
		// 		})
		// 		.catch(() => {
		// 			loading.close()
		// 		})
		// },
		hsjhandleSizeChangeMaterial(val) {
			this.hsjpageMaterial = 1
			this.hsjListlimitMaterial = val
			this.selectwlhxPageListFun()
		},
		// 点击页码
		hsjhandleCurrentChangeMaterial(val) {
			this.hsjpageMaterial = val
			this.selectwlhxPageListFun()
		},
		materialTax(row) {
			this.hanshuijiaShow = true;
			this.taxName = row.ORMTB703CA00;
			this.taxProductId = row.ORMTB703CA02;
			this.selectwlhxPageListFun();
		},
		addTaxlist() {
			this.taxFlag = true;
			this.taxId = 1;
			this.tableDataTaxAdd = [{
				id: 1,
				ORMTB703CA00: "",
				ORMTB703CA01: "",
				ORMTB703CA02: "",
				ORMTB703CA04: 1,
			}]
		},
		addTax() {
			this.tableDataTaxAdd.push({
				id: this.taxId++,
				ORMTB703CA00: "",
				ORMTB703CA01: "",
				ORMTB703CA02: "",
				ORMTB703CA04: 1,
			});
		},
		addMaterial() {
			this.tableDataMaterialAdd.push({
				id: this.materialId++,
				SETTB419CA01: "",
				SETTB419CA02: "",
				SETTB419CA03: "",
				SETTB419CA04: "",
				SETTB419CA00: "",
				SETTB419CA06: "",
				SETTB419CA07: "",
				money: "",
			});
		},
		deleteTax(index) {
			this.$confirm('此操作将移除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.tableDataTaxAdd.splice(index, 1);
				this.$message.success('删除成功');
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		// 查询企业
		optionLists() {
			var postData = {
				type: 2,
				SETTB100CA02: '', //用户类型
			}
			if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
				postData = {
					type: 2,
					ORMTB400ID: this.uobj.ormtb410.ORMTB400ID, //一级企业id
				}
			}
			if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
				postData = {
					type: 2,
					ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
				}
			}
			// var postData = {
			// 	SETTB100CA02: '', //用户类型
			// 	ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
			// }
			var List = [
				{
					SETTB99ID: '',
					SETTB99CA00: '全部',
				},
			]
			var url = '/set/settb100/selectSettb100ByCa02'
			this.axios
				.post(url, postData)
				.then(res => {
					if (res.data.code == 200) {
						var data = res.data.data
						// 二级企业
						this.enterpriseTwoOptionList = [...List, ...data];
						this.enterpriseTwoOptionListAll = data;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		//额外优惠列表
		querycusListExtra() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				SETTB99ID: this.enterpriseTwoExtra,
				ORMTB410ID: this.cusQueryNameExtra,
				limit: this.pagesize2,
				page: this.page2,
			}
			var fdmoList
			var url = 'set/settb414/selectPageList'
			this.axios
				.post(url, postData)
				.then(res => {
					console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.tableDataExtra = res.data.data;
						this.count2 = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		querycusListMetail() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var url = '/set/settb419/list'
			this.axios
				.post(url, { page: this.page3, limit: this.pagesize3 })
				.then(res => {
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.count4 = res.data.count;
						this.tableDataMaterial = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		// 含税价列表
		querycusListTax() {
			this.ykhsjChangJiaFun();
		},
		dgwlyhFun(e) {
			console.log(e)
			this.dgwlyh = e
		},
		addNewRow() {
			this.tableDatayh.push({
				id: this.nextId++,
				SETTB414CA00: '',
				SETTB414CA01: '',
				SETTB414CA02: '',
				SETTB414CA03: '',
				SETTB414CA04: '',
				SETTB414CA05: '',
				SETTB414CA07: 1,
				SETTB414CA08: '',
				djkj: '',
				zcyh: '',
				zczk: ''
			});
		},
		deleteRow(index) {
			this.$confirm('此操作将移除该行数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.tableDatayh.splice(index, 1);
				this.$message.success('删除成功');
			}).catch(() => {
				this.$message.info('已取消删除');
			});
		},
		pageMaterialList() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				SETTB109CA03: this.categoryMaterial, //物料类别
				SETTB109CA00: this.nameMaterial, //物料名称
				// SETTB109CD01: this.cjmsgobj.SETTB414CA01, //一级企业id
				SETTB99ID: this.productId, //二级企业ID
				ORMTB410ID: this.nameId,
				// ORMTB401CA01: this.materiaShowZJ, //企业是绑定还是自建
				page: this.pageMaterial,
				limit: this.limitMaterial,
			}
			this.materList = []
			var moList
			var url = '/set/settb109/selectPageListByCo'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						moList = res.data.data

						this.materList = moList
						this.pagingPageMaterial = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
				.catch(() => {
					loading.close()
				})
		},
		handleSizeChangeMaterial(val) {
			this.pageMaterial = 1
			this.limitMaterial = val
			this.pageMaterialList()
		},
		// 点击页码
		handleCurrentChangeMaterial(val) {
			this.pageMaterial = val
			this.pageMaterialList()
		},
		//用户单个物料优惠调控
		selectuserByPer() {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				ORMTB410ID: this.nameId,
				SETTB109ID: this.MaterialModify109ID, //物料ID
			}
			var url = '/set/settb109/selectByPer'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						console.log(res)

						if (res.data.data) {
							this.userName = this.nameTitle;
							this.individualDiscount = res.data.data.scyh;
							this.currentPrice = res.data.data.dqjg;
							// this.floatingAmount = 0 //浮动金额
							// this.floatingType = '1' //浮动类型-上浮/下调
							// this.floatingAmount = res.data.data.data.SETTB418CA07 //浮动金额
							// this.floatingType = JSON.stringify(res.data.data.data.SETTB418CA06) //浮动类型-上浮/下调
						} else {
							// this.floatingAmount = 0 //浮动金额
							// this.floatingType = '1' //浮动类型-上浮/下调
						}
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'success'
						// });
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},

		preservationDiscountModify() {
			if (this.floatingType === '') return this.$message.error('请选择浮动类型')
			if (this.floatingAmount == undefined)
				return this.$message.error('请输入浮动金额')

			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			var postData = {
				// SETTB99CA00: this.enterNameMaterialModify, //二级企业名称
				ORMTB410ID: this.nameId,
				SETTB109ID: this.MaterialModify109ID, //物料ID
				SETTB418CA06: this.floatingType, //上浮-下浮
				SETTB418CA07: this.floatingAmount, //浮动金额
				SETTB109CA01: this.currentPrice,
				newprice: this.adjustedPrice
			}
			var url = '/set/settb109/updateByPer'
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.discountShow = false
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.pageMaterialList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		MaterialQuery() {
			this.pageMaterial = 1
			this.pageMaterialList()
		},
		DiscountModify(item) {
			this.discountShow = true
			// this.queryMaterialTypeLsit('')
			this.MaterialModify109ID = item.SETTB109ID //物料ID
			this.enterNameMaterialModify = item.SETTB99CA00 //企业名称
			this.nameMaterialModify = item.SETTB109CA00 //物料名称
			this.floatingType = '';
			this.floatingAmount = 0;
			this.adjustedPrice = '';
			this.selectuserByPer();
		},
		//查询物料信息
		queryMaterialTypeLsit() {
			// console.log(type)
			// if (type === 0) {
			// 	this.materialTypeList = [{
			// 		SETTB206CA00: "",
			// 		SETTB206CA01: "全部"
			// 	}];
			// }
			// else {
			// 	this.materialTypeList = []
			// }
			this.materialTypeList = [
				{
					SETTB206CA00: '',
					SETTB206CA01: '全部',
				},
			]
			var url = '/set/settb109/selectSETTB206CA01'
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					var data = res.data.data
					this.materialTypeList = [...this.materialTypeList, ...data]
					// if (type === 0) {
					// 	this.materialTypeList = [...this.materialTypeList, ...data];
					// } else {
					// 	this.materialTypeList = data
					// }
				} else {
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		slmsgClick(row) {
			if (!row.SETTB414CA00) {
				this.$message({
					message: '请先选择客户',
					type: 'warning',
				})
				return
			}
			if (!row.SETTB414CA02) {
				this.$message({
					message: '请先选择企业',
					type: 'warning',
				})
				return
			}
			this.materShow = true
			this.cjmsgobj = row
			this.nameId = row.SETTB414CA00;
			this.nameTitle = row.SETTB414CA08;
			this.productId = row.SETTB414CA01;
			this.queryMaterialTypeLsit()
			this.pageMaterialList();
		},
		hasEmptyPropertyValue(arr) {
			for (const obj of arr) {
				for (const key in obj) {
					if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
						return true; // 找到空值属性，返回true
					}
				}
			}
			return false; // 未找到空值属性，返回false
		},
		//提交客户优惠信息
		khyhserve() {
			if (this.tableDatayh.length == 0) {
				this.$message({
					message: '请添加数据',
					type: 'warning',
				})
				return
			} else {
				if (this.hasEmptyPropertyValue(this.tableDatayh)) {
					this.$message({
						message: '请填写完整的数据',
						type: 'warning',
					})
					return
				}
			}
			if (this.editFlag) {//添加
				var url = '/set/settb414/save'
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)',
				})
				var postData = {
					list: this.tableDatayh,
				}
				this.axios
					.post(url, postData)
					.then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.querycusListExtra();
							this.discountsFlag = false;
						} else {
							this.$message({
								message: res.data.message,
								type: 'error',
							})
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
					.catch(() => {
						loading.close()
					})
			} else {//修改
				this.axios
					.post('set/settb414/update', this.tableDatayh[0])
					.then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.querycusListExtra();
							this.discountsFlag = false;
						} else {
							this.$message({
								message: res.data.message,
								type: 'error',
							})
						}
						setTimeout(() => {
							loading.close()
						}, 300)
					})
					.catch(() => {
						loading.close()
					})
			}

		},
		khyhqx() {
			// this.$refs.multipleTable.clearSelection()
			this.discountsFlag = false
			// this.multipleSelection = []
		},
		// 额外添加优惠
		addDiscounts() {
			this.discountsFlag = true;
			this.editFlag = true;
			this.nextId = 1;
			this.tableDatayh = [
				{
					id: 1,
					SETTB414CA00: '',
					SETTB414CA01: '',
					SETTB414CA02: '',
					SETTB414CA03: '',
					SETTB414CA04: '',
					SETTB414CA05: '',
					SETTB414CA07: 1,
					SETTB414CA08: '',
					djkj: '',
					zcyh: '',
					zczk: ''
				}
			]
		},
		// 切换tab
		selectTab(index) {
			this.tabIndex = index;
			if (this.tabIndex == 1) {
				this.enterpriseTwo = '';
				this.tableDataGradePre = [];
				this.queryGradePreLsit();
			} else if (this.tabIndex == 2) {
				this.enterpriseTwoExtra = '';
				this.cusQueryNameExtra = '';
				this.tableDataExtra = [];
				this.querycusListExtra();
			} else if (this.tabIndex == 3) {
				this.taxObj = {
					SETTB99ID: '',
					ORMTB410ID: '',
				}
				this.tableDataTax = [];
				this.querycusListTax();
			} else if (this.tabIndex == 4) {
				this.tableDataMaterial = [];
				this.querycusListMetail();
			}
		},
		// 获取等级优惠
		getGradePre() {
			var url = "/set/settb400/getSettb400List"
			var postData = {
				ORMTB410ID: this.rowkhId,
			}
		},
		// 提交等级优惠
		submissionGradePre() {
			var url = "/set/settb400/updateSettb400List"
			var settb400List = []
			this.tableDataGradePre.forEach((resitme) => {
				resitme.settb400List.forEach((itme) => {
					// itme.SETTB400ID = itme.SETTB400ID;
					// itme.djkjca06 = itme.djkj;
					// itme.zczkca06 = itme.zczk;
					// itme.zcyhca06 = itme.zcyh;
					settb400List.push(itme)
				})
			})
			var postData = {
				settb400List: settb400List,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.queryGradePreLsit()
					this.$message({
						message: '保存成功',
						type: 'success'
					});
					this.yhPreferentialShow = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		// 重置
		ResetGradePre() {
			this.tableDataGradePre.forEach((resitme) => {
				resitme.settb400List.forEach((itme) => {
					itme.djkj = itme.djkjOld;
					itme.zczk = itme.zczkOld;
					itme.zcyh = itme.zcyhOld;
				})
			})
		},
		submisyhsionGradePre() {
			this.yhPreferentialShow = true
			var url = "/set/settb400/confirm"
			var settb400List = []
			this.tableDatayhGradePre = []
			this.tableDataGradePre.forEach((resitme) => {
				resitme.settb400List.forEach((itme) => {
					// itme.SETTB400ID = itme.SETTB400ID;
					// itme.djkjca06 = itme.djkj;
					// itme.zczkca06 = itme.zczk;
					// itme.zcyhca06 = itme.zcyh;
					settb400List.push(itme)
				})
			})
			var postData = {
				settb400List: settb400List,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				console.log(res)
				if (res.data.code == 200) {
					this.tableDatayhGradePre = res.data.data;
					this.tableDatayhGradePre.forEach((resitme) => {
						resitme.forEach((itme) => {
							itme.djkjOld = itme.djkj;
							itme.zczkOld = itme.zczk;
							itme.zcyhOld = itme.zcyh;
						})
					})
					// this.$message({
					// 	message: '提交成功',
					// 	type: 'success'
					// });
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		init() {
			this.cusQueryName = this.historyInfo.cusQueryName
			this.currentPage = this.historyInfo.currentPage
			this.page = this.historyInfo.page
			this.pagesize = this.historyInfo.pagesize
			this.cusStatus = this.historyInfo.cusStatus
		},
		querycusList() {//等级优惠记录
			this.tableData = []
			var url = '/orm/ormtb410/selectPageList'
			var postData = {
				ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
				ORMTB410CA00: this.cusQueryName, //客户名称
				page: this.page,
				limit: this.pagesize,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
			})
			this.axios
				.post(url, postData)
				.then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data
						this.count = res.data.count
					}
					if (this.tableData.length > 0) {
						setTimeout(() => {
							loading.close()
						}, 300)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				})
				.catch(() => {
					loading.close()
				})
		},
		tableDetilsClick() {
			// this.queryEnterpriseTwoLsit()
			this.levelmangShow = true;
			this.tabIndex = 1;
			this.enterpriseTwo = '';
			this.tableDataGradePre = [];
			this.queryGradePreLsit()
		},
		// 等级优惠列表
		queryGradePreLsit() {
			this.tableDataGradePre = []
			var url = "/set/settb400/selectSettb400ByCA03"
			var postData = {
				ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级代码ID
				ORMTB400CA03: this.uobj.ormtb400.ORMTB400CA03, //一级客户代码
				SETTB99ID: this.enterpriseTwo,//二级企业ID
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)',
				customClass: 'custom-loading-mask'
			});
			this.$nextTick(() => {
				const mask = document.querySelector('.el-loading-mask');
				if (mask) {
					mask.style.zIndex = '10000';
				}
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataGradePre = res.data.data;
					this.tableDataGradePre.forEach((resitme) => {
						resitme.settb400List.forEach((itme) => {
							itme.djkjOld = itme.djkj;
							itme.zczkOld = itme.zczk;
							itme.zcyhOld = itme.zcyh;
						})
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		queryEnterpriseTwoLsit() {
			this.enterpriseTwoOptionList = [{
				SETTB99ID: "",
				SETTB99CA00: "全部",
			}]
			var url = "/set/settb100/selectSettb100ByCa02"
			var postData = {
				ORMTB400ID: this.uobj.ormtb400.ORMTB400ID,
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.enterpriseTwoOptionList = [...this.enterpriseTwoOptionList, ...res.data.data];
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val
			this.page = 1
			this.querycusList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.querycusList()
		},
		handleSizeChange2(val) {
			this.pagesize2 = val
			this.page2 = 1
			this.querycusListExtra()
		},
		handleCurrentChange2(val) {
			this.page2 = val
			this.querycusListExtra()
		},
		handleSizeChange3(val) {
			this.pagesize3 = val
			this.page3 = 1
			this.querycusListTax()
		},
		handleCurrentChange3(val) {
			this.page3 = val
			this.querycusListTax()
		},
		handleSizeChange4() {
			this.pagesize4 = val
			this.page4 = 1
			this.querycusListMetail()
		},
		handleCurrentChange4(val) {
			this.page4 = val
			this.querycusListMetail()
		},
	}
}
</script>
<style scoped>
/deep/.public_operatBtn {
	display: flex;
	justify-content: space-between;
}

.salesPreferentialDig-btn {
	text-align: center;
	margin: 30px 0 20px 0;
}

.customerManagementPC-table-btn {
	display: flex;
}

.levelmang_btn {
	cursor: pointer;
}

.systemCorporateAccount-dialog {
	padding: 0 20px;
}

.systemCorporateAccount-dialog-li {
	display: flex;
	box-sizing: border-box;
}

.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li {
	margin-top: 20px;
}

.systemCorporateAccount-dialog-btn {
	text-align: center;
	margin-top: 40px;
}

.systemCorporateAccount-wuliao-input>input {
	height: 40px;
	box-sizing: border-box;
	border: 1px solid #dcdfe6;
	border-radius: 5px;
	padding-left: 5px;
}

.SCADL-text {
	height: 30px;
	line-height: 30px;
	flex: 0.35;
	font-size: 18px;
	color: #333;
}

.SCADL-text span {
	color: red;
}

.SCADL-input {
	flex: 1;
	box-sizing: border-box;
}

.SCADL-input input {
	height: 40px;
	line-height: 30px;
	width: 99.9%;
	padding-left: 10px;
	border: 1px solid #999;
	color: #333;
	font-size: 18px;
	border-radius: 5px;
	box-sizing: border-box;
}

.SCADL-input .el-input {
	font-size: 18px;
}

.num {
	color: #333;
	font-size: 18px;
}

.cJ-btn {
	margin-top: 20px;
}

.shouQuanChangJia-dialog .el-checkbox {
	margin-bottom: 15px;
}

/deep/ .num .el-input .el-input__inner {
	font-size: 18px !important;
}

::v-deep .addPointer {
	cursor: pointer;
}

::v-deep .success-row {
	background-color: #81d3f8 !important;
}
</style>